exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nhtml[data-v-3f6ef94d],\nbody[data-v-3f6ef94d] {\n  width: 100vw;\n  height: 100vh;\n}\n.box[data-v-3f6ef94d] {\n  background: #000;\n  display: table;\n  height: 100vh;\n  text-align: center;\n  width: 100vw;\n}\n.inner[data-v-3f6ef94d] {\n  display: table-cell;\n  vertical-align: middle;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3f6ef94d","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/DashBoard/ChatBot/ImageDetailView.vue
// module id = lBAw
// module chunks = 3